import React from "react";
import { Table } from "@/components";

const getStatus = (status, record) => {
  let result = null;
  switch (status) {
    case "PENDING":
      result = "生成中，请稍后查看";
      break;
    case "RUNNING":
      result = "生成中，请稍后查看";
      break;
    case "ERROR":
      result = "导出失败";
      break;
    case "EXPIRED":
      result = "导出超时";
      break;
    case "COMPLETED":
      result = (
        <a href={record.downloadUrl} download>
          下载
        </a>
      );
      break;
    default:
    //   result = null;
  }
  return result;
};

const columns = [
  {
    title: <div className={"fw700 noWrap"}>序号</div>,
    key: "No",
    render: (text, record, index) => <div className={("noWrap", "colorBack")}>{index + 1}</div>,
  },
  {
    title: <div className={"fw700 noWrap"}>导出任务详情</div>,
    key: "detail",
    render: (text, record, index) => (
      <div className={("noWrap", "colorBack")}>
        {"面单账号:" +
          record.platformUsername +
          "; 网点名称:" +
          record.branchName +
          "; 时间段:" +
          record.startDate +
          "~" +
          record.endDate}
      </div>
    ),
  },
  {
    title: <div className={"fw700 noWrap"}>导出任务创建时间</div>,
    dataIndex: "dateCreated",
    render: (text, record, index) => <div className={("noWrap", "colorBack")}>{text}</div>,
  },
  {
    title: <div className="fw700 noWrap">操作</div>,
    dataIndex: "status",
    render: (text, record, index) => <div className={("noWrap", "colorBlack50")}>{getStatus(text, record)}</div>,
  },
];

function ExportEwaybillHistoryTable(props) {
  const { data, loading, onChange, userType } = props;
  return (
    <Table
      size="small"
      data={data}
      columns={columns}
      loading={loading}
      onPageChange={onChange}
      userType={userType}
    ></Table>
  );
}

export default ExportEwaybillHistoryTable;
